<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div class="wrappDiv">
      <el-form label-width="80px"
               width="90%"
               label-position="left"
               :model="dataForm"
               @keyup.enter.native="getDataList()">
        <!-- 课程名称-->
        <el-row class="margb10">
          <!-- <el-input v-model="currentRow"
                        clearable></el-input> -->
          <el-col :span="10">
          <el-col :span="4">
            <el-form-item :label="$t('offeringcd.cousername')">
            </el-form-item>
          </el-col>
          <el-col :span="8">
           <el-input style="width: 180px; padding-left: 0.5px;padding-right: 12.5px;"
                        v-model="dataForm.coursename"
                        clearable></el-input>
          </el-col>
          </el-col>
          <el-col :span="10">
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </el-col>
          <el-col :span="4">
            <el-col :span="24">
              <el-button class="M-search"
                         style="margin-bottom: 7px"
                         type="primary"
                         @click="getDataList()">{{ $t('query') }}</el-button>
            </el-col>
            <el-col :span="24">
              <el-button type="info"
                         class="el-back M-search M-margin-l"
                         @click="toggleSelection()">重置</el-button>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
      <!-- max-height="250" -->
      <div class="selectCertNameClass">
            <el-table v-loading="dataListLoading"
                ref="multipleTable"
                height="350"
                :data="dataList"
                border
                highlight-current-row
                style="width: 100%;"
                @select="checkboxChange">
        <el-table-column type="selection"
                         align="center"
                         width="50px">
          <!--<template slot-scope="scope">
            &lt;!&ndash; 添加一个多选框,控制选中与否 &ndash;&gt;
            <el-checkbox v-model="scope.row.checked" @change="checkboxChange(scope.row)"></el-checkbox>
          </template>-->
        </el-table-column>
        <!-- 课程代码 -->
        <el-table-column prop="courseCode"
                         :label="$t('offeringcd.cousercode')"
                         header-align="center"
                         :show-overflow-tooltip="true"
                         align="center"></el-table-column>
        <!-- 课程中文名称 -->
        <el-table-column prop="courseNameCn"
                         :label="$t('offeringcd.cousernamecn')"
                         header-align="center"
                         :show-overflow-tooltip="true"
                         align="center">
        </el-table-column>
        <!-- 课程英文缩写 -->
        <el-table-column prop="courseNameEn"
                         :label="$t('offeringcd.cousernameen')"
                         header-align="center"
                         :show-overflow-tooltip="true"
                         align="center">
        </el-table-column>
        <!-- 课程时长(天) -->
        <el-table-column prop="courseDays"
                         :label="$t('offeringcd.courseDays')"
                         header-align="center"
                         :show-overflow-tooltip="true"
                         align="center">
        </el-table-column>
        <!-- 课程团队分类 -->
        <el-table-column prop="courseTeamCatalogName"
                         :label="$t('offeringcd.couserTeamcatalog')"
                         header-align="center"
                         :show-overflow-tooltip="true"
                         align="center">
        </el-table-column>
        <!-- 课程分类 -->
        <el-table-column prop="courseCatalogName"
                         :label="$t('offeringcd.cousercatalog')"
                         header-align="center"
                         :show-overflow-tooltip="true"
                         align="center">
        </el-table-column>
        <!-- 课程类型 -->
        <el-table-column prop="courseKind"
                         :label="$t('offeringcd.cousertype')"
                         header-align="center"
                         :show-overflow-tooltip="true"
                         :formatter="coursekindformat"
                         align="center">
        </el-table-column>
        <!-- 课程状态 -->
        <el-table-column prop="courseStatus"
                         :label="$t('offeringcd.couserstate')"
                         header-align="center"
                         :show-overflow-tooltip="true"
                         :formatter="coursestatusformat"
                         align="center">
        </el-table-column>

      </el-table>
      </div>
      <el-row>
        <el-col :span="6">
          <el-row>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </el-row>
          <el-row>
            <!-- <span>注:该列表只显示已发布的课程</span> -->
          </el-row>
        </el-col>
        <el-col :span="14">
          <el-pagination :current-page="page"
                         :page-sizes="[10, 20, 50, 100]"
                         :page-size="limit"
                         :total="total"
                         layout="total, sizes, prev, pager, next, jumper"
                         @size-change="pageSizeChangeHandle"
                         @current-change="pageCurrentChangeHandle">
          </el-pagination>
        </el-col>
        <el-col :span="2">
        </el-col>
      </el-row>
    </div>
  </el-card>
</template>
<script>
import mixinViewModule from '@/mixins/view-module'
// import { moduleRoutes } from '@/router'
export default {
  mixins: [mixinViewModule],
  data () {
    // let _this = this
    let _this = this
    return {
      labelPosition: 'right',
      mixinViewModuleOptions: {
        activatedIsNeed: false,
        getDataListURL: '/learning/courseinfo/offeringpage',
        // getDataListURL: '/sys/commdict/list',
        getDataListIsPage: true,
        deleteIsBatch: true
      },
      // 课程类型
      newcourseKinds: _this.enums['courseKind'],
      // 课程类型
      // newcourseKind: _this.enums['courseKind'],
      // 面授课
      // 慕课
      // 微课
      // 混合式学习
      // 认证
      // 考试
      // 直播
      //  面授课
      // 混合式学习
      // 慕课
      // 微课
      // 资料
      // 辅导
      // 直播
      newcourseKind: [{
        value: '面授课',
        label: '面授课'
      }, {
        value: '慕课',
        label: '慕课'
      },
      {
        value: '微课',
        label: '微课'
      },
      {
        value: '混合式学习',
        label: '混合式学习'
      },
      {
        value: '资料',
        label: '资料'
      },
      {
        value: '辅导',
        label: '辅导'
      }, {
        value: '直播',
        label: '直播'
      }],
      datalist: [],
      currentRow: '',
      dataForm: {
        courseStatuslist: '20,80',
        courseBaseId: '',
        courseCode: '',
        coursename: ''
        // courseNameCn: '',
        // dictName: '',
        // dictType: '',
        // dictValue: ''
      }
    }
  },
  components: {
  },
  created () {
    this.mixinViewModuleOptions.getDataListURL = '/learning/courseinfo/offeringpage'
    this.mixinViewModuleOptions.getDataListIsPage = true
    this.getDataList()
    let resdata = this.dataList
    resdata.forEach(item => {
      item.checked = false
      // this.$message(item.courseCode)
    })
    this.dataList = resdata
  },

  methods: {
    close () {
      this.$emit('selectCodeClose')
    },
    pageSizeChangeHandle1 (val) {
      this.$message('' + val)
      this.dataList.forEach(item => {
        item.checked = false
      })
    },
    pageCurrentChangeHandle1 (val) {
      this.$message('' + val)
      this.dataList.forEach(item => {
        //  this.$message(item.courseCode)
        item.checked = false
      })
    },
    checkboxChange (selection, row) {
      this.$refs.multipleTable.clearSelection()
      if (selection.length === 0) { // 判断selection是否有值存在
        return
      }
      if (row) {
        this.$refs.multipleTable.toggleRowSelection(row, true)
        this.$emit('offeringcodeadd', row)
      }
      this.$emit('selectCodeClose')
    },
    toggleSelection () {
      this.$refs.multipleTable.clearSelection()
      this.dataForm.coursename = ''
      this.$emit('again')
    },
    coursestatusformat (row, column, cellValue) {
      if (cellValue === '10') {
        return '未发布'
      } else if (cellValue === '20') {
        return '已发布'
      } else if (cellValue === '30') {
        return '已下架'
      } else { return ' ' }
    },
    coursekindformat (row, column, cellValue) {
      // this.newcourseKinds.forEach(row => {
      // })
      if (cellValue === '10') {
        return '面授课程'
      } else if (cellValue === '20') {
        return '驻店培训'
      } else if (cellValue === '30') {
        return '远程培训'
      } else { return ' ' }
    }

  }
}
</script>
<style>
  .selectCertNameClass thead .el-table-column--selection .cell {
    display: none !important;
  }
</style>
<style lang="scss" scoped>
/*.el-step__icon.is-text {*/
/*      border-radius: 50%;*/
/*      border: 15px solid;*/
/*      border-color: inherit;*/
/*  }*/
/* .el-form--label-top .el-form-item__label {
    display: inline-block;
    text-align: left;
    padding: 0 0 10px;
} */
.wrappDiv {
  .el-form-item__label {
    float: left;
  }
}
// .has-gutter .el-checkbox__inner {
//   display:none
// }
.el-row {
  margin-bottom: 1px;
}
</style>
